import React, { useState } from 'react';

const HeroBlock = ({ data, isSelected, onSelect, onUpdate, isPreview }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(data);

  const handleSave = () => {
    onUpdate(editData);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditData(data);
    setIsEditing(false);
  };

  const handleInputChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (isPreview) {
    return (
      <section style={{
        position: 'relative',
        height: '500px',
        backgroundImage: data.backgroundType === 'image' && data.backgroundImage 
          ? `url(${data.backgroundImage})` 
          : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: data.textColor || '#ffffff'
      }}>
        {data.backgroundType === 'image' && data.backgroundImage && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: `rgba(0, 0, 0, ${data.overlayOpacity || 0.5})`
          }} />
        )}
        <div style={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          maxWidth: '800px',
          padding: '0 2rem'
        }}>
          <h1 style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            lineHeight: '1.2'
          }}>
            {data.title || 'Welcome to Our Store'}
          </h1>
          <p style={{
            fontSize: '1.25rem',
            marginBottom: '2rem',
            opacity: 0.9
          }}>
            {data.subtitle || 'Discover amazing products and services'}
          </p>
          {data.ctaText && (
            <a
              href={data.ctaLink || '#'}
              style={{
                display: 'inline-block',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                padding: '1rem 2rem',
                borderRadius: '0.5rem',
                textDecoration: 'none',
                fontWeight: '600',
                border: '2px solid white',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'white';
                e.target.style.color = '#333';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                e.target.style.color = 'white';
              }}
            >
              {data.ctaText}
            </a>
          )}
        </div>
      </section>
    );
  }

  return (
    <div
      style={{
        border: isSelected ? '2px solid #007bff' : '2px solid #dee2e6',
        borderRadius: '0.5rem',
        backgroundColor: 'white',
        marginBottom: '1rem',
        position: 'relative'
      }}
      onClick={onSelect}
    >
      {/* Block Header */}
      <div style={{
        padding: '0.75rem 1rem',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #dee2e6',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '1.25rem' }}>🎯</span>
          <span style={{ fontWeight: '600' }}>Hero Section</span>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsEditing(!isEditing);
          }}
          style={{
            padding: '0.25rem 0.5rem',
            backgroundColor: isEditing ? '#dc3545' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '0.25rem',
            cursor: 'pointer',
            fontSize: '0.75rem'
          }}
        >
          {isEditing ? 'Cancel' : 'Edit'}
        </button>
      </div>

      {/* Block Content */}
      <div style={{ padding: '1rem' }}>
        {isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {/* Title */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Title
              </label>
              <input
                type="text"
                value={editData.title || ''}
                onChange={(e) => handleInputChange('title', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              />
            </div>

            {/* Subtitle */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Subtitle
              </label>
              <input
                type="text"
                value={editData.subtitle || ''}
                onChange={(e) => handleInputChange('subtitle', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              />
            </div>

            {/* Background Type */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Background Type
              </label>
              <select
                value={editData.backgroundType || 'image'}
                onChange={(e) => handleInputChange('backgroundType', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              >
                <option value="image">Image</option>
                <option value="video">Video</option>
                <option value="gradient">Gradient</option>
              </select>
            </div>

            {/* Background Image */}
            {editData.backgroundType === 'image' && (
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                  Background Image URL
                </label>
                <input
                  type="url"
                  value={editData.backgroundImage || ''}
                  onChange={(e) => handleInputChange('backgroundImage', e.target.value)}
                  placeholder="https://example.com/image.jpg"
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    border: '1px solid #dee2e6',
                    borderRadius: '0.25rem',
                    fontSize: '1rem'
                  }}
                />
              </div>
            )}

            {/* CTA Text */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Call-to-Action Text
              </label>
              <input
                type="text"
                value={editData.ctaText || ''}
                onChange={(e) => handleInputChange('ctaText', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              />
            </div>

            {/* CTA Link */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Call-to-Action Link
              </label>
              <input
                type="text"
                value={editData.ctaLink || ''}
                onChange={(e) => handleInputChange('ctaLink', e.target.value)}
                placeholder="/shop"
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  fontSize: '1rem'
                }}
              />
            </div>

            {/* Text Color */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Text Color
              </label>
              <input
                type="color"
                value={editData.textColor || '#ffffff'}
                onChange={(e) => handleInputChange('textColor', e.target.value)}
                style={{
                  width: '100%',
                  padding: '0.25rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem',
                  height: '40px'
                }}
              />
            </div>

            {/* Overlay Opacity */}
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500' }}>
                Overlay Opacity: {editData.overlayOpacity || 0.5}
              </label>
              <input
                type="range"
                min="0"
                max="1"
                step="0.1"
                value={editData.overlayOpacity || 0.5}
                onChange={(e) => handleInputChange('overlayOpacity', parseFloat(e.target.value))}
                style={{ width: '100%' }}
              />
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
              <button
                onClick={handleSave}
                style={{
                  flex: 1,
                  padding: '0.5rem',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.25rem',
                  cursor: 'pointer'
                }}
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                style={{
                  flex: 1,
                  padding: '0.5rem',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.25rem',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div style={{
            height: '200px',
            backgroundImage: data.backgroundType === 'image' && data.backgroundImage 
              ? `url(${data.backgroundImage})` 
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: data.textColor || '#ffffff',
            borderRadius: '0.25rem',
            position: 'relative'
          }}>
            {data.backgroundType === 'image' && data.backgroundImage && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: `rgba(0, 0, 0, ${data.overlayOpacity || 0.5})`,
                borderRadius: '0.25rem'
              }} />
            )}
            <div style={{
              position: 'relative',
              zIndex: 1,
              textAlign: 'center'
            }}>
              <h3 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 'bold' }}>
                {data.title || 'Hero Section'}
              </h3>
              <p style={{ margin: '0.5rem 0 0 0', opacity: 0.9 }}>
                {data.subtitle || 'Click edit to customize'}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroBlock;
